import { createRouter } from "@tanstack/react-router";

import type { AuthUser } from "./modules/auth";
import type { UserMenu } from "./modules/auth/dtos/get-profile-data-response-dto";
import { routeTree } from "./routeTree.gen";

export type RouterContext = {
  auth: {
    isAuthenticated: boolean;
    userData: AuthUser | null;
    userMenus: UserMenu[];
  };
};

// Extend the router context type
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }

  interface RouteContext extends RouterContext {}
}

export const router = createRouter({
  routeTree,
  context: {
    auth: {
      isAuthenticated: false,
      userData: null,
      userMenus: []
    }
  }
});
